var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 18.3359H14.9999V16.6693C14.9999 15.2885 13.8807 14.1693 12.4999 14.1693H7.49992C6.11921 14.1693 4.99992 15.2885 4.99992 16.6693V18.3359H3.33325V16.6693C3.33325 14.3681 5.19874 12.5026 7.49992 12.5026H12.4999C14.8011 12.5026 16.6666 14.3681 16.6666 16.6693V18.3359ZM9.99992 10.8359C7.23849 10.8359 4.99992 8.59735 4.99992 5.83594C4.99992 3.07451 7.23849 0.835938 9.99992 0.835938C12.7613 0.835938 14.9999 3.07451 14.9999 5.83594C14.9999 8.59735 12.7613 10.8359 9.99992 10.8359ZM9.99992 9.16927C11.8408 9.16927 13.3333 7.67689 13.3333 5.83594C13.3333 3.99499 11.8408 2.5026 9.99992 2.5026C8.15897 2.5026 6.66659 3.99499 6.66659 5.83594C6.66659 7.67689 8.15897 9.16927 9.99992 9.16927Z",
    fill: "#061232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/myAccount.1e65b4831da49946a6ee1b978bca7b6b.svg";
export { ForwardRef as ReactComponent };